import React, { useState, useEffect } from 'react';
import api from '../api';
import { FaPlus, FaEdit, FaTrash, FaTimes, FaCheck, FaTags } from 'react-icons/fa';
import { theme, t } from '../theme';
import { useConfirm } from './ConfirmProvider';

const CategoriasEmbalagemModal = ({ fecharModal, recarregar }) => {
    const [categorias, setCategorias] = useState([]);
    const [novaCategoria, setNovaCategoria] = useState('');
    const [editando, setEditando] = useState(null);
    const [categoriaEditada, setCategoriaEditada] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const confirm = useConfirm();

    useEffect(() => { carregarCategorias(); }, []);

    const carregarCategorias = async () => {
        try {
            setLoading(true);
            const res = await api.get('/api/embalagens/categorias');
            setCategorias(res.data || []);
        } catch { setError('Erro ao carregar categorias'); }
        finally { setLoading(false); }
    };

    const adicionarCategoria = async () => {
        const nome = novaCategoria.trim();
        if (!nome) { setError('Digite o nome da categoria'); return; }
        if (categorias.includes(nome)) { setError('Categoria já existe'); return; }
        // Adiciona localmente (categorias de embalagem são texto livre)
        setCategorias(prev => [...prev, nome].sort());
        setNovaCategoria('');
        setError('');
        // Tenta criar via API (pode não fazer nada se não tem embalagens)
        try { await api.post('/api/embalagens/categorias', { nome }); } catch {}
        recarregar();
    };

    const salvarEdicao = async () => {
        const nova = categoriaEditada.trim();
        if (!nova) { setError('Digite o nome'); return; }
        try {
            await api.put('/api/embalagens/categorias', { categoria_antiga: editando, categoria_nova: nova });
            await carregarCategorias();
            setEditando(null);
            setError('');
            recarregar();
        } catch (err) { setError(err.response?.data?.erro || 'Erro ao editar'); }
    };

    const excluirCategoria = async (categoria) => {
        if (!await confirm(`Excluir "${categoria}"? Embalagens ficarão sem categoria.`, { danger: true, confirmText: 'Excluir' })) return;
        try {
            await api.delete('/api/embalagens/categorias', { data: { nome: categoria } });
            await carregarCategorias();
            setError('');
            recarregar();
        } catch (err) { setError(err.response?.data?.erro || 'Erro ao excluir'); }
    };

    return (
        <div style={t.overlay}>
            <div style={{ ...t.modal, maxWidth: 480 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ width: 40, height: 40, borderRadius: 12, background: theme.colors.primaryLight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <FaTags size={18} color={theme.colors.primary} />
                        </div>
                        <div>
                            <h3 style={{ ...t.h2, margin: 0 }}>Categorias de Embalagem</h3>
                            <p style={{ ...t.subtitle, margin: '2px 0 0' }}>{categorias.length} cadastrada{categorias.length !== 1 ? 's' : ''}</p>
                        </div>
                    </div>
                    <button onClick={fecharModal} style={t.btnIcon}><FaTimes size={16} color={theme.colors.textMuted} /></button>
                </div>

                {error && <div style={t.error}>{error}<button onClick={() => setError('')} style={{ float: 'right', background: 'none', border: 'none', cursor: 'pointer', color: theme.colors.danger }}><FaTimes size={12} /></button></div>}

                <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
                    <input value={novaCategoria} onChange={e => setNovaCategoria(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && adicionarCategoria()}
                        placeholder="Nova categoria..." style={{ ...t.input, flex: 1 }} />
                    <button onClick={adicionarCategoria} style={t.btnPrimary}><FaPlus size={12} /> Adicionar</button>
                </div>

                {loading ? (
                    <div style={{ textAlign: 'center', padding: 24, color: theme.colors.textMuted }}>Carregando...</div>
                ) : categorias.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 24, color: theme.colors.textMuted }}>Nenhuma categoria.</div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {categorias.map(categoria => (
                            <div key={categoria} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 12px', borderRadius: 10, background: editando === categoria ? theme.colors.bgSection : 'transparent', transition: 'background 0.1s' }}>
                                {editando === categoria ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
                                        <input value={categoriaEditada} onChange={e => setCategoriaEditada(e.target.value)}
                                            onKeyDown={e => { if (e.key === 'Enter') salvarEdicao(); if (e.key === 'Escape') setEditando(null); }}
                                            style={{ ...t.input, flex: 1 }} autoFocus />
                                        <button onClick={salvarEdicao} style={t.btnIcon}><FaCheck size={14} color={theme.colors.success} /></button>
                                        <button onClick={() => setEditando(null)} style={t.btnIcon}><FaTimes size={14} color={theme.colors.textMuted} /></button>
                                    </div>
                                ) : (
                                    <>
                                        <span style={{ fontSize: 14, color: theme.colors.text }}>{categoria}</span>
                                        <div style={{ display: 'flex', gap: 2 }}>
                                            <button onClick={() => { setEditando(categoria); setCategoriaEditada(categoria); }} style={t.btnIcon}><FaEdit size={13} color={theme.colors.info} /></button>
                                            <button onClick={() => excluirCategoria(categoria)} style={t.btnIcon}><FaTrash size={13} color={theme.colors.danger} /></button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                <div style={{ marginTop: 20, textAlign: 'right' }}>
                    <button onClick={fecharModal} style={t.btnSecondary}>Fechar</button>
                </div>
            </div>
        </div>
    );
};

export default CategoriasEmbalagemModal;
